module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/activities/activities_01.png";